import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Button, IconButton, LinearProgress, } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import SignedImage from '../aws/SignedImage';
var UploadState;
(function (UploadState) {
    UploadState["Choosing"] = "Choosing";
    UploadState["Confirm"] = "Confirm";
    UploadState["Uploading"] = "Uploading";
    UploadState["Processing"] = "Processing";
    UploadState["Display"] = "Display";
})(UploadState || (UploadState = {}));
const AssetDisplay = ({ asset }) => {
    if (!asset)
        return null;
    if (asset?.mimeType && asset.mimeType.startsWith('image/')) {
        if (asset.status === 'processed') {
            return (_jsx(Box, { sx: { width: '100%', mt: 1 }, children: _jsx(SignedImage, { bucket: asset.repository.bucket, bucketKey: `${asset.path}/original`, status: asset.status, alt: asset.name, customStyle: { width: '100%', height: 'auto' } }) }));
        }
        return _jsx(Box, { children: "Asset is being processed" });
    }
    return (_jsx(Box, { sx: {
            padding: 2,
            borderRadius: 1,
            textAlign: 'left',
            margin: '0 auto',
        }, children: _jsxs(Button, { variant: "contained", component: "a", href: asset.url, target: "_blank", rel: "noopener noreferrer", startIcon: _jsx(InsertDriveFileIcon, {}), children: ["Download", ' ', asset.name] }) }));
};
const AssetDisplayObs = observer(AssetDisplay);
const UploadViewFile = ({ repository, asset, onAssetChange, onUploadStateChange, uploadPrefix, }) => {
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadState, setUploadState] = useState(UploadState.Display);
    const store = useStore();
    const monitorUploadProgress = (progressPercent) => {
        setUploadProgress(progressPercent);
        if (progressPercent === 100) {
            console.log('Upload completed');
            setUploadState(UploadState.Display);
            if (onUploadStateChange) {
                onUploadStateChange(UploadState.Display);
            }
        }
    };
    const handleUploadClick = (file) => {
        console.log('Handle upload click');
        if (!file)
            return;
        setUploadState(UploadState.Uploading);
        onUploadStateChange?.(UploadState.Uploading);
        store.upload(file, repository, onAssetChange, monitorUploadProgress, true, 'attachment', uploadPrefix);
    };
    const handleFileSelected = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            onUploadStateChange?.(UploadState.Confirm);
            handleUploadClick(file);
        }
    };
    return (_jsxs(Box, { children: [uploadState === UploadState.Display && (_jsxs(Box, { children: [_jsx(AssetDisplayObs, { asset: asset }), _jsxs(Box, { sx: { mt: 2 }, children: [_jsx("input", { id: "file-input", name: "file-input", accept: "*", type: "file", onChange: handleFileSelected, style: { display: 'none' } }), _jsxs("label", { htmlFor: "file-input", children: [_jsx("span", { style: {
                                            position: 'absolute',
                                            width: '1px',
                                            height: '1px',
                                            margin: '-1px',
                                            border: 0,
                                            padding: 0,
                                            clip: 'rect(0,0,0,0)',
                                            overflow: 'hidden',
                                        }, children: "Upload file" }), _jsxs(Box, { sx: { display: 'flex', alignItems: 'center' }, children: [_jsx(IconButton, { component: "span", className: "site-system-button-primary", "aria-label": "Upload file", children: _jsx(AttachFileIcon, {}) }), asset?.name && (_jsx(Box, { sx: {
                                                    ml: 1,
                                                    fontSize: '0.8rem',
                                                    color: 'text.secondary',
                                                    whiteSpace: 'nowrap',
                                                }, children: `Selected: ${asset.name}` }))] })] })] })] })), uploadState === UploadState.Uploading && (_jsx(Box, { sx: { width: '100%' }, children: _jsx(LinearProgress, { variant: "determinate", value: uploadProgress }) }))] }));
};
UploadViewFile.defaultProps = {
    onUploadStateChange: undefined,
};
export default observer(UploadViewFile);
//# sourceMappingURL=UploadViewFile.js.map